import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { UPDATE_PREVIEW_PLAYER_PROPS, VOD_MESSAGE_TYPES } from '../../constants'
import styles from './styles'
import {
  MutedIcon,
  UnmutedIcon,
  PreviewPauseIcon,
  PreviewPlayIcon,
} from '../icons'

// eslint-disable-next-line consistent-return
const getControlIcon = (type, state) => {
  if (type === 'mute') {
    return state ? <MutedIcon /> : <UnmutedIcon />
  }
  return state ? <PreviewPlayIcon /> : <PreviewPauseIcon />
}

const PreviewPlayerControl = ({
  controlType,
  shouldDisplay,
  disabled,
  userPaused,
}) => {
  const [muted, setMuted] = useState(true)
  const [paused, setPaused] = useState(false)
  const { PAUSED, UNPAUSED } = VOD_MESSAGE_TYPES

  useEffect(() => {
    if (userPaused) return
    // eslint-disable-next-line no-unused-expressions
    disabled ? setPaused(true) : setPaused(false)
  }, [disabled])

  const setMutePlayer = () => {
    const playerMuted = !muted
    setMuted(playerMuted)

    window.postMessage({
      type: UPDATE_PREVIEW_PLAYER_PROPS,
      newData: { muted: playerMuted },
    }, '*')
  }

  const playPausePlayer = () => {
    if (disabled) return

    const playerPaused = !paused
    setPaused(playerPaused)

    window.postMessage({
      type: UPDATE_PREVIEW_PLAYER_PROPS,
      newData: { paused: playerPaused },
    }, '*')

    window.postMessage({
      type: playerPaused ? PAUSED : UNPAUSED,
    }, '*')
  }

  const icon = getControlIcon(controlType, controlType === 'mute' ? muted : paused)

  return (
    <div className="preview-player-control">
      <button
        className={`preview-control ${disabled ? ' disabled' : ''}`}
        type="button"
        onClick={controlType === 'mute' ? setMutePlayer : playPausePlayer}
        style={{ opacity: shouldDisplay ? 1 : 0, transition: 'opacity 0.3s' }}
      >
        { icon }
      </button>
      <style jsx>{styles}</style>
    </div>
  )
}

PreviewPlayerControl.propTypes = {
  controlType: PropTypes.string,
  shouldDisplay: PropTypes.bool,
  disabled: PropTypes.bool,
  userPaused: PropTypes.bool,
}

PreviewPlayerControl.defaultProps = {
  controlType: 'mute',
  shouldDisplay: true,
  disabled: false,
  userPaused: false,
}

export default PreviewPlayerControl
